const PERMISSION_KEY= "personalize:user_screener_client";
const PAGE_URL = {
    USER_SCREENER_CLIENT_PAGE: "/admin/personalize/user-screener-client"
}

export {PERMISSION_KEY, PAGE_URL}

